"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Theme = _interopRequireDefault(require("../../common/Theme"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Button = exports["default"] = /*#__PURE__*/function (_Component) {
  function Button(props) {
    var _this;
    _classCallCheck(this, Button);
    _this = _callSuper(this, Button, [props]);
    _defineProperty(_this, "color", _Theme["default"].getStyleVar("--white-wh-900"));
    _defineProperty(_this, "hoverColor", _Theme["default"].getStyleVar("--neon-blue-nb-050"));
    _defineProperty(_this, "activeColor", _Theme["default"].getStyleVar("--neon-blue-nb-100"));
    _defineProperty(_this, "filledColor", _Theme["default"].getStyleVar("--neon-blue-nb-500"));
    _defineProperty(_this, "filledHoverColor", _Theme["default"].getStyleVar("--neon-blue-nb-700"));
    _defineProperty(_this, "filledActiveColor", _Theme["default"].getStyleVar("--neon-blue-nb-900"));
    _defineProperty(_this, "iconColor", _Theme["default"].getStyleVar("--neon-blue-nb-500"));
    _defineProperty(_this, "filledIconColor", _Theme["default"].getStyleVar("--white-wh-900"));
    _this.state = {
      disabled: props.disabled ? true : false
    };
    return _this;
  }
  _inherits(Button, _Component);
  return _createClass(Button, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.disabled !== this.props.disabled) {
        this.setState({
          disabled: this.props.disabled || false
        });
      }
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled) {
      this.setState({
        disabled: !enabled
      });
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props = this.props,
        hasBorder = _this$props.hasBorder,
        hasFocusBorder = _this$props.hasFocusBorder,
        background = _this$props.background,
        label = _this$props.label,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? "lg" : _this$props$size,
        theme = _this$props.theme,
        variant = _this$props.variant,
        path = _this$props.path,
        href = _this$props.href,
        onClick = _this$props.onClick,
        autoFocus = _this$props.autoFocus,
        icon = _this$props.icon,
        startIcon = _this$props.startIcon,
        endIcon = _this$props.endIcon,
        sx = _this$props.sx,
        className = _this$props.className,
        badgeProps = _this$props.badgeProps,
        color = _this$props.color,
        hoverColor = _this$props.hoverColor,
        activeColor = _this$props.activeColor,
        labelColor = _this$props.labelColor,
        target = _this$props.target,
        filledLabelColor = _this$props.filledLabelColor,
        showLabelFromBreakpoint = _this$props.showLabelFromBreakpoint,
        type = _this$props.type,
        form = _this$props.form;
      var disabled = this.state.disabled;
      var btnClass = "klayo-button" + (icon ? " klayo-iconbutton" : "") + (className ? " " + className : "") + (size ? " klayo-button-" + size : "") + (variant && !icon ? " klayo-button-" + variant : "");
      var isOutlined = variant === "outlined";
      var isFilled = variant === "filled";
      var style = _objectSpread(_defineProperty(_defineProperty(_defineProperty({
        border: hasBorder ? !disabled ? "1px solid var(--neon-blue-nb-100)!important" : "1px solid var(--grey-gr-300)!important" : null,
        background: background || null,
        padding: icon ? Button.iconPadding[size] : Button.padding[size],
        backgroundColor: color || (isFilled ? this.filledColor : icon ? null : this.color),
        "&:hover": {
          backgroundColor: hoverColor || (isFilled ? this.filledHoverColor : this.hoverColor)
        },
        "&:active": {
          backgroundColor: activeColor || (isFilled ? this.filledActiveColor : this.activeColor)
        },
        "&:focus::before": hasFocusBorder ? {
          border: "2px solid var(--neon-blue-nb-400)",
          borderRadius: Button.focusBorderRadius[size],
          top: isOutlined ? Button.outlinedfocusOffset : Button.focusOffset,
          right: isOutlined ? Button.outlinedfocusOffset : Button.focusOffset,
          bottom: isOutlined ? Button.outlinedfocusOffset : Button.focusOffset,
          left: isOutlined ? Button.outlinedfocusOffset : Button.focusOffset
        } : {}
      }, "& .MuiButton-startIcon, & .MuiButton-endIcon", {
        width: Button.iconSize[size]
      }), "& .klayo-button_label", {
        color: isFilled ? filledLabelColor : labelColor,
        fontSize: Button.fontSize[size],
        fontWeight: isFilled ? "400" : "600"
      }), '& .MuiButton-startIcon svg path[fill="#111827"], & .MuiButton-startIcon svg path[fill="#727DF9"], & .MuiButton-endIcon svg path[fill="#111827"], & .MuiButton-endIcon svg path[fill="#727DF9"], & .MuiButton-endIcon svg path[fill="#1B3DF2"]', {
        fill: isFilled ? this.filledIconColor : this.iconColor
      }), sx);
      if (theme && showLabelFromBreakpoint) {
        style[theme.breakpoints.down(showLabelFromBreakpoint)] = {
          padding: "0!important",
          minWidth: Button.size[size]
        };
        style["& .klayo-button_label"] = _defineProperty(_defineProperty({}, theme.breakpoints.down(showLabelFromBreakpoint), {
          display: "none"
        }), theme.breakpoints.up(showLabelFromBreakpoint), {
          display: "block"
        });
        style["& .MuiButton-startIcon, & .MuiButton-endIcon"][theme.breakpoints.down(showLabelFromBreakpoint)] = {
          margin: "0"
        };
      }
      return icon ? /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        className: btnClass,
        onClick: onClick,
        disabled: disabled,
        disableRipple: true,
        to: path,
        component: path ? _reactRouterDom.NavLink : null,
        sx: style
      }, badgeProps && badgeProps.show !== false ? /*#__PURE__*/_react["default"].createElement(_material.Badge, badgeProps, icon) : icon) : /*#__PURE__*/_react["default"].createElement(_material.Button, {
        className: btnClass,
        href: href,
        target: target,
        to: path,
        component: path ? _reactRouterDom.NavLink : href ? "a" : null,
        startIcon: startIcon,
        endIcon: endIcon,
        onClick: onClick,
        disableRipple: true,
        disabled: disabled,
        autoFocus: autoFocus,
        sx: style,
        type: type,
        form: form
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "klayo-button_label"
      }, label));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        tooltip = _this$props2.tooltip,
        toolTipEnterDelay = _this$props2.toolTipEnterDelay;
      return tooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: tooltip,
        enterDelay: toolTipEnterDelay
      }, this.renderButton()) : this.renderButton();
    }
  }]);
}(_react.Component);
_defineProperty(Button, "padding", {
  sm: "16px 12px",
  md: "10px 16px",
  lg: "12px 24px"
});
_defineProperty(Button, "iconPadding", {
  sm: "8px",
  md: "8px",
  lg: "12px"
});
_defineProperty(Button, "iconSize", {
  sm: "20px",
  md: "20px",
  lg: "24px"
});
_defineProperty(Button, "fontSize", {
  sm: "14px",
  md: "14px",
  lg: "16px"
});
_defineProperty(Button, "size", {
  sm: "32px",
  md: "40px",
  lg: "40px"
});
_defineProperty(Button, "borderRadius", {
  sm: "16px",
  md: "20px",
  lg: "24px"
});
_defineProperty(Button, "focusBorderRadius", {
  sm: "20px",
  md: "24px",
  lg: "28px"
});
_defineProperty(Button, "focusOffset", "-4px");
_defineProperty(Button, "outlinedfocusOffset", "-5px");
_defineProperty(Button, "defaultProps", {
  size: "lg",
  variant: "outlined",
  labelColor: _Theme["default"].getStyleVar("--grey-gr-900"),
  filledLabelColor: _Theme["default"].getStyleVar("--white-wh-900"),
  target: null,
  hasFocusBorder: true,
  background: null
});